class SelectherCampaigns extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.slides = [...this.querySelectorAll('.se-campaign-slide')];
    this.tabs = [...this.querySelectorAll('[data-slide]')];
    this.index = 0;
    this.animations = [];
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelector('.se-campaign-controls').hidden = false;
    this.tabs.forEach((button, index) => button.addEventListener('click', () => this.show(index), options));
    this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
    this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
    this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
    this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
    }, options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => this.schedule(), options);
    this.slides.forEach((slide, index) => { slide.inert = index !== 0; });
    this.schedule();
  }
  async show(index) {
    const next = (index + this.slides.length) % this.slides.length;
    if (next === this.index) return;
    const previous = this.index;
    this.index = next;
    this.animations.forEach(animation => animation.cancel());
    this.slides.forEach((slide, i) => {
      slide.hidden = i !== next && i !== previous;
      slide.inert = i !== next;
      slide.setAttribute('aria-hidden', String(i !== next));
    });
    this.tabs.forEach((button, i) => {
      if (i === next) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
    if (!this.motion.matches) {
      const timing = { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
      this.animations = [
        this.slides[previous].animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], timing),
        this.slides[next].animate([{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }], timing)
      ];
      try { await Promise.all(this.animations.map(animation => animation.finished)); }
      catch { return; }
    }
    this.slides[previous].hidden = true;
    this.schedule();
  }
  schedule() {
    clearTimeout(this.timer);
    if (!this.motion.matches && !this.hovered && !this.focused && !document.hidden) {
      this.timer = setTimeout(() => this.show(this.index + 1), 6000);
    }
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.animations?.forEach(animation => animation.cancel());
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('selecther-campaigns')) customElements.define('selecther-campaigns', SelectherCampaigns);
